"use strict";

require("core-js/modules/es.date.to-string.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.initCookieDisclaimer = initCookieDisclaimer;
var _react = _interopRequireWildcard(require("react"));
var PropTypes = _interopRequireWildcard(require("prop-types"));
var _universalCookie = _interopRequireDefault(require("universal-cookie"));
var _utils = require("@sys42/utils");
require("./styles.module.compiled.css");
var styles = _interopRequireWildcard({
  "wrapper": "styles-module__wrapper___1I_qj",
  "contentFooter": "styles-module__contentFooter___SIam9"
});
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var cookies = new _universalCookie["default"]();
function fetchRegion(cookieDomain) {
  return new Promise(function (resolve, reject) {
    if (cookies.get("region")) {
      resolve(cookies.get("region"));
    } else {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", "https://www.userbrain.com/region/check.json");
      xhr.onload = function () {
        if (this.status >= 200 && this.status < 300) {
          var data = JSON.parse(xhr.response);
          cookies.set("region", data.region, {
            path: "/",
            domain: cookieDomain,
            expires: new Date(new Date().getTime() + 1000 * 60 * 60 * 24)
          });
          resolve(data.region);
        } else {
          reject("Error fetching region");
        }
      };
      xhr.onerror = function () {
        reject("Error fetching region");
      };
      xhr.send();
    }
  });
}
function initCookieDisclaimer(cookieDomain) {
  if (typeof window === "undefined") {
    return;
  } else {
    if (!window.userbrainCookieDisclaimerRegionPromise) {
      window.userbrainCookieDisclaimerCookieDomain = cookieDomain;
      window.userbrainCookieDisclaimerRegionPromise = fetchRegion(cookieDomain);
    }
    return window.userbrainCookieDisclaimerRegionPromise;
  }
}
var UserbrainCookieDisclaimer = /*#__PURE__*/function (_Component) {
  _inherits(UserbrainCookieDisclaimer, _Component);
  var _super = _createSuper(UserbrainCookieDisclaimer);
  function UserbrainCookieDisclaimer(props) {
    var _this;
    _classCallCheck(this, UserbrainCookieDisclaimer);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "setNoConsentCountry", function () {
      var exdays = 365;
      var expires = new Date();
      expires.setTime(expires.getTime() + exdays * 24 * 60 * 60 * 1000);
      cookies.set("ncc", true, {
        path: "/",
        domain: _this.cookieDomain,
        expires: expires
      });
      _this.props.onConsentGiven();
    });
    _defineProperty(_assertThisInitialized(_this), "onClickCookieConsentAgree", function () {
      var exdays = 365;
      var expires = new Date();
      expires.setTime(expires.getTime() + exdays * 24 * 60 * 60 * 1000);
      cookies.set("CookieConsent", true, {
        path: "/",
        domain: _this.cookieDomain,
        expires: expires
      });
      _this.props.onConsentGiven();
      _this.setState({
        show: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onClickCookieConsentDecline", function () {
      var exdays = 30;
      var expires = new Date();
      expires.setTime(expires.getTime() + exdays * 24 * 60 * 60 * 1000);
      cookies.set("CookieConsentDeclined", true, {
        path: "/",
        domain: _this.cookieDomain,
        expires: expires
      });
      _this.setState({
        show: false
      });
    });
    _this.state = {
      show: false
    };
    return _this;
  }
  _createClass(UserbrainCookieDisclaimer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var url = new URL(window.location.href);
      if (url.searchParams.get("ncc")) {
        this.setNoConsentCountry();
      }
      this.cookieDomain = null;
      if (typeof window !== "undefined") {
        if (!window.userbrainCookieDisclaimerRegionPromise) {
          throw new Error("initCookieDisclaimer must be called before using UserbrainCookieDisclaimer");
        }
        this.cookieDomain = window.userbrainCookieDisclaimerCookieDomain;
        if (!cookies.get("ncc") && !cookies.get("CookieConsentDeclined") && !cookies.get("CookieConsent") && !cookies.get("cookie_consent")) {
          window.userbrainCookieDisclaimerRegionPromise.then(function (region) {
            if (region === "eu" || region === "gb") {
              _this2.setState({
                show: true
              });
            } else {
              _this2.setNoConsentCountry();
            }
          })["catch"](function () {
            _this2.setState({
              show: true
            });
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.state.show && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _utils.concatClassNames)(this.props.className, styles.wrapper),
        role: "dialog",
        "aria-label": "Cookies on our Site"
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h2", null, /*#__PURE__*/_react["default"].createElement("span", {
        role: "img",
        "aria-label": "cookie"
      }, "\uD83C\uDF6A"), " ", "Cookies on our Site"), /*#__PURE__*/_react["default"].createElement("p", null, "We use cookies to remember your login details and collect statistics to optimize site functionality.", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://www.userbrain.com/privacy"
      }, "Read our privacy policy"))), /*#__PURE__*/_react["default"].createElement("div", {
        className: styles.contentFooter
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: this.props.classNameButtonAgree,
        onClick: this.onClickCookieConsentAgree
      }, "Allow cookies"), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: this.props.classNameButtonDecline,
        onClick: this.onClickCookieConsentDecline
      }, "Decline"))));
    }
  }]);
  return UserbrainCookieDisclaimer;
}(_react.Component);
UserbrainCookieDisclaimer.propTypes = {
  onConsentGiven: PropTypes.func.isRequired,
  classNameButtonAgree: PropTypes.string,
  classNameButtonDecline: PropTypes.string
};
UserbrainCookieDisclaimer.defaultProps = {
  classNameButtonAgree: "",
  classNameButtonDecline: ""
};
var _default = UserbrainCookieDisclaimer;
exports["default"] = _default;